import { orderedProjects, galleryItems } from '@/lib/projects';
import GoldenPhotographyWork from '@/components/feature/golden-work/GoldenPhotographyWork';
import SectionShell from '@/components/feature/SectionShell';
import SectionHeader from '@/components/feature/SectionHeader';
import { WorkEntrance } from '@/lib/motion/Reveal';

export default function SelectedWork() {
  return (
    <SectionShell id="work" labelledBy="work-title" innerClassName="work-archive-shell">
      <SectionHeader
        index="02"
        name="Work"
        titleId="work-title"
        title="Selected work"
        meta={`${galleryItems.length} photographs · ${orderedProjects.length} projects · 2024–2026`}
      />
      {/* Outer entrance only: animates opacity + `top`, never transform (keeps fixed layers intact). */}
      <WorkEntrance>
        <div className="work-frame">
          <GoldenPhotographyWork galleryItems={galleryItems} />
        </div>
      </WorkEntrance>
    </SectionShell>
  );
}